import { lazy } from 'react';
import Loadable from '@root/routes/Loadable';
import ACLGuard from '@comp/ACLGuard';

const CronJobTemplateIndex = Loadable(lazy(() => import('@pages/merchant/_account/_job/_template/index')));

export const templateRoute = {
    path: 'template',
    children: [
        {
            path: 'account/cron_job',
            element: (
                <ACLGuard type={'template'} can={'edit'}>
                    <CronJobTemplateIndex />
                </ACLGuard>
            ),
        }
    ],
};
